// Import hooks.
import {
	useInputForm,
	UseInputFormResult,
} from '@app/hooks/view/input';
// Import props.
import {
	InputCheckboxProps,
	InputFormProps,
} from '@app/props';

interface UseInputCheckboxParameters {
	id: string;
	label: string;
	helperText?: string;
	required: boolean;
	disabled: boolean;
	isChecked: boolean,
	showValidation?: boolean;
}

type UseInputCheckboxResults = UseInputFormResult<boolean, InputCheckboxProps>

const useInputCheckbox = (params: UseInputCheckboxParameters): UseInputCheckboxResults => {

	// #region exported methods

	/**
	 * Returns props for form input. 
	 **/
	const applyCheckboxProps = (): InputCheckboxProps => {
		// First apply the form input props.
		let formProps: InputFormProps = applyProps();
		// Then apply the checkbox props.
		return {
			...formProps,
			helperText: params.helperText,
			isChecked: other.value,
			onChange: other.setInput
		}
	};

	// #endregion exported methods


	// #region variables

	// Instantiate the 'checkbox' input.
	const { applyProps, ...other } = useInputForm<boolean>({
		id: params.id,
		label: params.label,
		required: params.required,
		disabled: params.disabled,
		initialInput: params.isChecked,
		showValidation: params.showValidation,
	});

	// #endregion variables


	return {
		applyProps: applyCheckboxProps,
		...other,
	};
}

// Export parameters.
export {
	UseInputCheckboxParameters,
}

// Export results.
export {
	UseInputCheckboxResults,
}

export default useInputCheckbox;